import { memo } from "react";

const LINER_GRADIENT_ID = "BELL";

interface Props {
  className?: string;
}

const BellIcon = memo(({ className }: Props) => {
  return (
    <svg
      height="25"
      viewBox="0 0 20 25"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <linearGradient
        id={LINER_GRADIENT_ID}
        x1="79.484987%"
        x2="22.458479%"
        y1="100%"
        y2="2.154082%"
      >
        <stop offset="0" stopColor="#B647B7" />
        <stop offset="1" stopColor="#F683B6" />
      </linearGradient>
      <path
        d="m13.8469323 1.26374085c0-.6979388-.5657768-1.26374085-1.2637408-1.26374085-.6979641 0-1.2637409.56580205-1.2637409 1.26374085v.94780563h-.7044091c-2.81193715 0-5.13924229 2.1862843-5.31476326 4.99271151l-.27929937 4.46537771c-.1064828 1.7025117-.67806015 3.3432264-1.65248016 4.7433249-.88042297 1.2650046-.09662563 3.0122527 1.43367607 3.1958742l4.30572935.5167437v1.3580159c0 1.9193696 1.55591777 3.4752873 3.47528737 3.4752873s3.4752873-1.5559177 3.4752873-3.4752873v-1.3580159l4.3056914-.5167437c1.5303902-.1836215 2.3141623-1.9308696 1.433714-3.1958742-.9744706-1.4000985-1.5460605-3.0408132-1.6524675-4.7433249l-.2792868-4.46537771c-.1755336-2.80642721-2.5028387-4.99271151-5.3147885-4.99271151h-.7044091zm-3.2318908 2.8434169c-1.81096594 0-3.30981313 1.40802214-3.42285475 3.21543693l-.27928673 4.46532722c-.12814332 2.0487766-.81593428 4.0229926-1.98849622 5.7078119-.06362935.0914948-.00698849.2177425.10362675.2310118l4.72343361.5667878c1.88101504.2257041 3.78243954.2257041 5.66339144 0l4.7234841-.5667878c.1105774-.0132693.1673193-.139517.1036268-.2310118-1.1724988-1.6848193-1.8603529-3.6590353-1.9884962-5.7078119l-.2792868-4.46532722c-.1131048-1.80741479-1.6119014-3.21543693-3.4228421-3.21543693zm1.96815 18.95611265c-.8724867 0-1.5796761-.7071893-1.5796761-1.579676v-.9478057h3.1593521v.9478057c0 .8724867-.7071894 1.579676-1.579676 1.579676z"
        fill={`url(#${LINER_GRADIENT_ID})`}
        fillRule="evenodd"
        transform="translate(-3)"
      />
    </svg>
  );
});

export default BellIcon;
